import React, { useEffect, useState } from 'react';
import Header from '../Core/Header';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart, Bar, 
} from "recharts";

import { PieChart, Pie, Cell,  } from 'recharts';
import { doctors } from '../../Assets/dummyDoc';
import { useNavigate } from 'react-router-dom';
import { patient } from '../../Assets/dummyPatient';
import { useSelector } from 'react-redux';
import { getProfile } from '../../Services/Operations/ProductAPI';


const data2 = [
  { month: "Jan", profit: 1500, expenses: 900, patients: 50 },
  { month: "Feb", profit: 2200, expenses: 1200, patients: 170 },
  { month: "Mar", profit: 1800, expenses: 1400, patients: 1090 },
  { month: "Apr", profit: 3200, expenses: 2000, patients: 330 },
  { month: "May", profit: 5000, expenses: 2800, patients: 470 },
];


const data = [
  { name: 'Daily', admissions: 50 },
  { name: 'Weekly', admissions: 75 },
  { name: 'Monthly', admissions: 150 },
  { name: 'Yearly', admissions: 200 },
  { name: 'Year', admissions: 250 },
];




const Dashboard = () => {
     const[list,setList]=useState(patient)
      const[manage,setManage]=useState("")
     const navigate=useNavigate()
       const token = useSelector((state) =>JSON.parse( state.auth.token));

       const handleGetProfile=async()=>{
        try {
          console.log(token);
          
          const res=await getProfile(token)
          console.log(res);
          
        } catch (error) {
          console.log(error);
          
        }
       }


      useEffect(() => {
        handleGetProfile()
      }, [])
      
  return (
   <div style={{height:"100vh",width:"100%",overflow:"hidden"}}>
    <Header/>
 <section
  style={{
    marginTop: "80px",
    width: "100%",
    height: "calc(100vh - 80px)",
    boxSizing: "border-box",
    padding: "16px",
    display: "flex",
    gap: "16px",
    background: "linear-gradient(135deg, #eff3f7, #f8fbff, #e5f4ff)",
    overflow: "hidden",
    fontFamily: "Inter, system-ui, sans-serif",
    color: "#12345b",
  }}
>
  {/* ================= SIDEBAR ================= */}
  <aside
    style={{
      width: "245px",
      minWidth: "220px",
      height: "100%",
      flexShrink: 0,
      boxSizing: "border-box",
      padding: "18px 14px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      background: "linear-gradient(180deg, #ffffff, #edf7ff)",
      border: "1px solid #cfe8fc",
      borderRadius: "18px",
      boxShadow: "0 8px 25px rgba(38, 113, 170, 0.10)",
      overflowY: "auto",
      position: "relative",
    }}
  >
    <div style={{ padding: "4px 8px 18px" }}>
      <p
        style={{
          margin: 0,
          fontSize: "20px",
          fontWeight: "850",
          color: "#12345b",
          letterSpacing: "-0.6px",
        }}
      >
        Swasthya Khata
      </p>
      <p
        style={{
          margin: "5px 0 0",
          fontSize: "12px",
          color: "#71869d",
          fontWeight: "600",
        }}
      >
        ADMIN DASHBOARD
      </p>
    </div>

    {/* Music */}
    <div
      onMouseEnter={() => setManage("music")}
      onMouseLeave={() => setManage("")}
      style={{
        borderRadius: "12px",
        background:
          manage === "music"
            ? "linear-gradient(110deg, #2387ff, #53b7ff)"
            : "#edf5fd",
        color: manage === "music" ? "white" : "#244568",
        overflow: "hidden",
        cursor: "pointer",
        transition: "0.2s ease",
      }}
    >
      <div
        style={{
          padding: "13px 10px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "14px",
          fontWeight: "750",
        }}
      >
        <img
          src="/Assets/add.png"
          alt=""
          style={{ width: "23px", height: "23px", objectFit: "contain" }}
        />
        <span style={{ flex: 1 }}>Music manage</span>
        <span>{manage === "music" ? "⌄" : "›"}</span>
      </div>

      {manage === "music" && (
        <div
          onClick={() => navigate("/music")}
          style={{
            padding: "10px 12px 13px 43px",
            fontSize: "13px",
            fontWeight: "600",
            background: "rgba(255,255,255,0.14)",
            cursor: "pointer",
          }}
        >
          All Musics <span style={{ marginLeft: "5px" }}>→</span>
        </div>
      )}
    </div>

    {/* Hospital */}
    <div
      onMouseEnter={() => setManage("doctor")}
      onMouseLeave={() => setManage("")}
      style={{
        borderRadius: "12px",
        background: manage === "doctor" ? "#e0efff" : "transparent",
        cursor: "pointer",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "13px 10px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "14px",
          fontWeight: "750",
          color: "#244568",
        }}
      >
        <img
          src="/Assets/location.png"
          alt=""
          style={{ width: "23px", height: "23px", objectFit: "contain" }}
        />
        <span style={{ flex: 1 }}>Hospital manage</span>
        <span>{manage === "doctor" ? "⌄" : "›"}</span>
      </div>

      {manage === "doctor" && (
        <div
          onClick={() => navigate("/hospitals")}
          style={{
            padding: "10px 12px 13px 43px",
            fontSize: "13px",
            color: "#3675b8",
            fontWeight: "600",
          }}
        >
          Search Hospitals →
        </div>
      )}
    </div>

    {/* Diagnostic */}
    <div
      onMouseEnter={() => setManage("diagnostic")}
      onMouseLeave={() => setManage("")}
      style={{
        borderRadius: "12px",
        background: manage === "diagnostic" ? "#e0efff" : "transparent",
        cursor: "pointer",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "13px 10px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "14px",
          fontWeight: "750",
          color: "#244568",
        }}
      >
        <img
          src="/Assets/health.png"
          alt=""
          style={{ width: "23px", height: "23px", objectFit: "contain" }}
        />
        <span style={{ flex: 1 }}>Diagnostic manage</span>
        <span>{manage === "diagnostic" ? "⌄" : "›"}</span>
      </div>

      {manage === "diagnostic" && (
        <div
          onClick={() => navigate("/diagonistics")}
          style={{
            padding: "10px 12px 13px 43px",
            fontSize: "13px",
            color: "#3675b8",
            fontWeight: "600",
          }}
        >
          Search Diagnostics →
        </div>
      )}
    </div>

    {/* Doctors */}
    <div
      onMouseEnter={() => setManage("doctors")}
      onMouseLeave={() => setManage("")}
      style={{
        borderRadius: "12px",
        background: manage === "doctors" ? "#e0efff" : "transparent",
        cursor: "pointer",
        overflow: "hidden",
      }}
    >
      <div
        onClick={() => navigate("/doctors")}
        style={{
          padding: "13px 10px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "14px",
          fontWeight: "750",
          color: "#244568",
        }}
      >
        <img
          src="/Assets/add-user.png"
          alt=""
          style={{ width: "23px", height: "23px", objectFit: "contain" }}
        />
        <span style={{ flex: 1 }}>Doctors manage</span>
        <span>{manage === "doctors" ? "⌄" : "›"}</span>
      </div>

      {manage === "doctors" && (
        <div
          onClick={() => navigate("/doctors")}
          style={{
            padding: "10px 12px 13px 43px",
            fontSize: "13px",
            color: "#3675b8",
            fontWeight: "600",
          }}
        >
          Our Doctors →
        </div>
      )}
    </div>

    {/* Patients */}
    <div
      onMouseEnter={() => setManage("patient")}
      onMouseLeave={() => setManage("")}
      style={{
        borderRadius: "12px",
        background: manage === "patient" ? "#e0efff" : "transparent",
        cursor: "pointer",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "13px 10px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontSize: "14px",
          fontWeight: "750",
          color: "#244568",
        }}
      >
        <img
          src="/Assets/add-user.png"
          alt=""
          style={{ width: "23px", height: "23px", objectFit: "contain" }}
        />
        <span style={{ flex: 1 }}>Patients manage</span>
        <span>{manage === "patient" ? "⌄" : "›"}</span>
      </div>

      {manage === "patient" && (
        <div
          style={{
            padding: "0 8px 10px 43px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <p
            onClick={() => navigate("/find-doctors")}
            style={{
              margin: 0,
              fontSize: "12px",
              color: "#3675b8",
              fontWeight: "600",
            }}
          >
            Patient data upload →
          </p>
          <p
            onClick={() => navigate("/patients")}
            style={{
              margin: 0,
              fontSize: "12px",
              color: "#3675b8",
              fontWeight: "600",
            }}
          >
            Our Patients →
          </p>
        </div>
      )}
    </div>

    {/* Track data */}
    <div
      style={{
        marginTop: "8px",
        padding: "13px 10px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        borderRadius: "12px",
        background: "#e0efff",
        fontSize: "14px",
        fontWeight: "750",
        color: "#244568",
        cursor: "pointer",
      }}
    >
      <img
        src="/Assets/add-user.png"
        alt=""
        style={{ width: "23px", height: "23px", objectFit: "contain" }}
      />
      <span style={{ flex: 1 }}>Track Your Data</span>
      <span>›</span>
    </div>

    {/* Logout — original UI preserved */}
    <div
      style={{
        marginTop: "auto",
        padding: "13px 12px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        borderRadius: "12px",
        background: "linear-gradient(110deg, #132c47, #254c70)",
        color: "white",
        fontSize: "14px",
        fontWeight: "750",
        cursor: "pointer",
        flexShrink: 0,
      }}
    >
      <img
        src="/Assets/turn-off.png"
        alt=""
        style={{
          width: "23px",
          height: "23px",
          objectFit: "contain",
          background: "white",
          borderRadius: "50%",
          padding: "3px",
          boxSizing: "border-box",
        }}
      />
      <span style={{ flex: 1 }}>Log Out</span>
      <span>›</span>
    </div>
  </aside>

  {/* ================= MAIN DASHBOARD ================= */}
  <main
    style={{
      flex: 1,
      minWidth: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      overflowY: "auto",
      overflowX: "hidden",
      paddingRight: "2px",
    }}
  >
    {/* Hero Banner */}
    <div
  style={{
    position: "relative",
    minHeight: "300px",
    flexShrink: 0,
    borderRadius: "18px",
    overflow: "hidden",
    background: "#153b64",
    boxShadow: "0 8px 24px rgba(45, 110, 170, 0.15)",
    border: "1px solid #cde6fa",
    isolation: "isolate",
  }}
>
  {/* Full-cover background video */}
  <video
    autoPlay
    muted
    loop
    playsInline
    preload="auto"
    style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
      zIndex: -2,
    }}
  >
    <source src="/Assets/biotech1.mp4" type="video/mp4" />
  </video>

  {/* Video overlay for text readability */}
  <div
    style={{
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(90deg, rgba(220,240,255,0.96) 0%, rgba(220,240,255,0.82) 42%, rgba(20,65,110,0.20) 100%)",
      zIndex: -1,
    }}
  />

  <div
    style={{
      position: "relative",
      zIndex: 1,
      padding: "clamp(18px, 3vw, 30px)",
      minHeight: "300px",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
      gap: "24px",
    }}
  >
    {/* Heading */}
    <div>
      <p
        style={{
          margin: 0,
          fontSize: "clamp(26px, 3vw, 40px)",
          lineHeight: 1.2,
          fontWeight: "850",
          color: "#153b64",
          letterSpacing: "-1px",
        }}
      >
        Welcome to
      </p>

      <p
        style={{
          margin: "3px 0 0",
          fontSize: "clamp(28px, 3.3vw, 43px)",
          lineHeight: 1.2,
          fontWeight: "850",
          color: "#1674dc",
          letterSpacing: "-1.2px",
        }}
      >
        Dashboard Admin
      </p>
    </div>

    {/* Request cards */}
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        width: "100%",
      }}
    >
      {/* Hospital Request */}
      <div
        onClick={() => navigate("/request")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "235px",
          maxWidth: "100%",
          padding: "10px 13px",
          boxSizing: "border-box",
          borderRadius: "14px",
          background: "rgba(255, 255, 255, 0.58)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          border: "1px solid rgba(255,255,255,0.8)",
          boxShadow: "0 8px 24px rgba(20,65,110,0.12)",
          cursor: "pointer",
          transition: "all 0.25s ease",
        }}
      >
        <div
          style={{
            width: "42px",
            height: "42px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(231,242,255,0.85)",
            borderRadius: "12px",
            flexShrink: 0,
          }}
        >
          <img
            src="/Assets/hospital-1.png"
            alt=""
            style={{
              width: "28px",
              height: "28px",
              objectFit: "contain",
            }}
          />
        </div>

        <span
          style={{
            flex: 1,
            fontSize: "13px",
            fontWeight: "750",
            color: "#173c64",
          }}
        >
          Hospital's Request
        </span>

        <span
          style={{
            minWidth: "26px",
            height: "26px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            background: "#ef3333",
            color: "white",
            fontSize: "12px",
            fontWeight: "800",
            boxShadow: "0 2px 8px rgba(239,51,51,0.25)",
          }}
        >
          3
        </span>
      </div>

      {/* Diagnostic Request */}
      <div
        onClick={() => navigate("/request")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "245px",
          maxWidth: "100%",
          padding: "10px 13px",
          boxSizing: "border-box",
          borderRadius: "14px",
          background: "rgba(255, 255, 255, 0.58)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          border: "1px solid rgba(255,255,255,0.8)",
          boxShadow: "0 8px 24px rgba(20,65,110,0.12)",
          cursor: "pointer",
          transition: "all 0.25s ease",
        }}
      >
        <div
          style={{
            width: "42px",
            height: "42px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(231,242,255,0.85)",
            borderRadius: "12px",
            flexShrink: 0,
          }}
        >
          <img
            src="/Assets/hospital.png"
            alt=""
            style={{
              width: "28px",
              height: "28px",
              objectFit: "contain",
            }}
          />
        </div>

        <span
          style={{
            flex: 1,
            fontSize: "13px",
            fontWeight: "750",
            color: "#173c64",
          }}
        >
          Diagnostic's Request
        </span>

        <span
          style={{
            minWidth: "26px",
            height: "26px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            background: "#ef3333",
            color: "white",
            fontSize: "12px",
            fontWeight: "800",
            boxShadow: "0 2px 8px rgba(239,51,51,0.25)",
          }}
        >
          3
        </span>
      </div>
    </div>
  </div>
</div>

    {/* Lower Dashboard Grid */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1.05fr) minmax(0, 1fr)",
        gap: "16px",
        alignItems: "start",
      }}
    >
      {/* Patient Overview */}
      <div
        style={{
          minWidth: 0,
          padding: "18px",
          background: "rgba(255,255,255,0.96)",
          border: "1px solid #d9eafa",
          borderRadius: "18px",
          boxShadow: "0 5px 18px rgba(45,110,170,0.07)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            marginBottom: "18px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#e9f3ff",
                fontSize: "22px",
              }}
            >
              👥
            </div>
            <h3
              style={{
                margin: 0,
                fontSize: "17px",
                fontWeight: "800",
                color: "#173c64",
              }}
            >
              Patients Overview
            </h3>
          </div>

          <button
            onClick={() => navigate("/patients")}
            style={{
              padding: "9px 12px",
              borderRadius: "10px",
              background: "#f5faff",
              border: "1px solid #cde5fb",
              color: "#216bb4",
              fontSize: "12px",
              fontWeight: "700",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            View All →
          </button>
        </div>

        {list.length > 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(145px, 1fr))",
              gap: "12px",
            }}
          >
            {list.map((item, index) => (
              <div
                key={item?.id || item?.registered || index}
                style={{
                  minWidth: 0,
                  padding: "12px",
                  boxSizing: "border-box",
                  borderRadius: "14px",
                  background: "linear-gradient(145deg, #f8fcff, #edf7ff)",
                  border: "1px solid #d6eaff",
                  display: "flex",
                  flexDirection: "column",
                  gap: "9px",
                }}
              >
                <img
                  src="/Assets/patient.webp"
                  alt=""
                  style={{
                    width: "58px",
                    height: "58px",
                    borderRadius: "13px",
                    objectFit: "cover",
                    background: "#dcebf8",
                  }}
                />

                <p
                  style={{
                    margin: 0,
                    fontSize: "13px",
                    fontWeight: "800",
                    color: "#153b64",
                    overflowWrap: "anywhere",
                  }}
                >
                  {item.name}
                </p>

                <p
                  style={{
                    margin: 0,
                    fontSize: "11px",
                    color: "#58718c",
                    lineHeight: 1.5,
                    overflowWrap: "anywhere",
                  }}
                >
                  📍 {item.Address}
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "5px",
                    fontSize: "10px",
                    color: "#425c77",
                  }}
                >
                  <span>Age: {item.Age}</span>
                  <span>Reg: {item.registered}</span>
                </div>

                <div style={{ borderTop: "1px solid #dceaf7", paddingTop: "9px" }}>
                  <p
                    style={{
                      margin: "0 0 7px",
                      fontSize: "11px",
                      fontWeight: "800",
                      color: "#294966",
                    }}
                  >
                    Assigned Doctors
                  </p>

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                    }}
                  >
                    {item.AssignedDoc.map((i, docIndex) => (
                      <span
                        key={docIndex}
                        style={{
                          fontSize: "10px",
                          padding: "5px 7px",
                          borderRadius: "20px",
                          background: "#153f68",
                          color: "#ffffff",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {i}
                      </span>
                    ))}
                  </div>
                </div>

                <div style={{ borderTop: "1px solid #dceaf7", paddingTop: "9px" }}>
                  <p
                    style={{
                      margin: "0 0 7px",
                      fontSize: "11px",
                      fontWeight: "800",
                      color: "#294966",
                    }}
                  >
                    Assigned Diagnostic Center
                  </p>

                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                    }}
                  >
                    {item.disease.map((i, diseaseIndex) => (
                      <span
                        key={diseaseIndex}
                        style={{
                          fontSize: "10px",
                          padding: "5px 7px",
                          borderRadius: "20px",
                          background: "#d8f4e8",
                          color: "#146344",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {i}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              padding: "40px 10px",
              textAlign: "center",
              color: "#7b91a8",
              fontSize: "13px",
            }}
          >
            No patient records available.
          </div>
        )}
      </div>

      {/* Analytics */}
      <div
        style={{
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {/* Monthly chart */}
        <div
          style={{
            minWidth: 0,
            height: "390px",
            boxSizing: "border-box",
            padding: "18px",
            background: "rgba(255,255,255,0.97)",
            border: "1px solid #d9eafa",
            borderRadius: "18px",
            boxShadow: "0 5px 18px rgba(45,110,170,0.07)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "18px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#e9f3ff",
                fontSize: "21px",
                flexShrink: 0,
              }}
            >
              📈
            </div>
            <h3
              style={{
                margin: 0,
                fontSize: "15px",
                fontWeight: "800",
                color: "#173c64",
                lineHeight: 1.5,
              }}
            >
              Monthly Profit, Expenses and Patient Admissions
            </h3>
          </div>

          <div style={{ flex: 1, minHeight: 0, width: "100%" }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={data2}
                margin={{ top: 10, right: 8, left: -15, bottom: 0 }}
              >
                <CartesianGrid stroke="#e2edf7" strokeDasharray="3 3" />
                <XAxis
                  dataKey="month"
                  tick={{ fill: "#627b96", fontSize: 11 }}
                  axisLine={{ stroke: "#d8e7f5" }}
                  tickLine={false}
                />
                <YAxis
                  tick={{ fill: "#627b96", fontSize: 11 }}
                  axisLine={false}
                  tickLine={false}
                />
                <Tooltip
                  contentStyle={{
                    borderRadius: "12px",
                    border: "1px solid #dbeafe",
                    boxShadow: "0 5px 18px rgba(30,70,110,0.10)",
                    fontSize: "12px",
                  }}
                />
                <Legend wrapperStyle={{ fontSize: "12px", paddingTop: "12px" }} />

                <Line
                  type="monotone"
                  dataKey="profit"
                  name="Profit"
                  stroke="#1677ff"
                  strokeWidth={3}
                  dot={{ r: 3, fill: "#1677ff" }}
                  activeDot={{ r: 5 }}
                />
                <Line
                  type="monotone"
                  dataKey="expenses"
                  name="Expenses"
                  stroke="#ff8737"
                  strokeWidth={3}
                  dot={{ r: 3, fill: "#ff8737" }}
                  activeDot={{ r: 5 }}
                />
                <Line
                  type="monotone"
                  dataKey="patients"
                  name="Patients"
                  stroke="#15945b"
                  strokeWidth={3}
                  dot={{ r: 3, fill: "#15945b" }}
                  activeDot={{ r: 5 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Admissions chart */}
        <div
          style={{
            minWidth: 0,
            height: "280px",
            boxSizing: "border-box",
            padding: "18px",
            background: "rgba(255,255,255,0.97)",
            border: "1px solid #d9eafa",
            borderRadius: "18px",
            boxShadow: "0 5px 18px rgba(45,110,170,0.07)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "12px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#e9f3ff",
                fontSize: "21px",
                flexShrink: 0,
              }}
            >
              📊
            </div>

            <h3
              style={{
                margin: 0,
                fontSize: "15px",
                fontWeight: "800",
                color: "#173c64",
                lineHeight: 1.5,
              }}
            >
              Patient Admissions
              <span style={{ fontWeight: "500", fontSize: "12px" }}>
                {" "}
                (Daily, Weekly, Monthly, Yearly)
              </span>
            </h3>
          </div>

          <div style={{ flex: 1, minHeight: 0, width: "100%" }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data}
                margin={{ top: 10, right: 5, left: -15, bottom: 0 }}
              >
                <CartesianGrid stroke="#e2edf7" strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  tick={{ fill: "#627b96", fontSize: 11 }}
                  axisLine={{ stroke: "#d8e7f5" }}
                  tickLine={false}
                />
                <YAxis
                  tick={{ fill: "#627b96", fontSize: 11 }}
                  axisLine={false}
                  tickLine={false}
                />
                <Tooltip
                  contentStyle={{
                    borderRadius: "12px",
                    border: "1px solid #dbeafe",
                    boxShadow: "0 5px 18px rgba(30,70,110,0.10)",
                    fontSize: "12px",
                  }}
                />
                <Legend wrapperStyle={{ fontSize: "12px", paddingTop: "8px" }} />
                <Bar
                  dataKey="admissions"
                  name="Admissions"
                  fill="#2463a6"
                  radius={[6, 6, 0, 0]}
                  maxBarSize={42}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  </main>

  {/* Responsive layout */}
  <style>{`
    @media (max-width: 1100px) {
      .dashboard-responsive-placeholder {
        display: none;
      }
    }

    @media (max-width: 900px) {
      section:has(aside) {
        height: auto !important;
        min-height: calc(100vh - 80px);
        overflow: visible !important;
        flex-direction: column !important;
      }

      section:has(aside) > aside {
        width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
      }

      section:has(aside) > aside > div {
        max-width: 100%;
      }

      section:has(aside) > main {
        overflow: visible !important;
      }

      section:has(aside) > main > div:last-child {
        grid-template-columns: minmax(0, 1fr) !important;
      }
    }

    @media (max-width: 600px) {
      section:has(aside) {
        padding: 10px !important;
        gap: 12px !important;
      }

      section:has(aside) > main > div:first-child > div:last-child {
        padding: 18px !important;
      }

      section:has(aside) > main > div:last-child > div {
        padding: 12px !important;
      }
    }
  `}</style>
</section>
      
    </div>
  );
}

export default Dashboard;
